import { Location } from '@angular/common';
import { Component, AfterViewChecked, ElementRef, ViewChild, HostListener, NgZone, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { ErrorDialogComponent } from 'src/app/error-dialog/error-dialog.component';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

interface MessageResponsePair {
  message: string;
  response?: string[];
  completeResponse?: any;
  loading?: boolean;
  currentPage?: number;
  totalPages?: number;
  isLiked?: boolean;
  isDisliked?: boolean;
}
@Component({
  selector: 'app-product-queries',
  templateUrl: './product-queries.component.html',
  styleUrls: ['./product-queries.component.css']
})
export class ProductQueriesComponent implements AfterViewChecked {
  inputValue: string = '';
  translatedText: string = ''; // Translated text
  isListening: boolean = false; // Tracks if listening
  isProcessing: boolean = false;
  voiceError: string = ''; // Error messages for voice
  recognition: any;
  processedResults: Set<string> = new Set();
  debounceTimeout: any = null;
  combinedTranscript: string = '';
  isVoiceEnabled = true;
  mediaRecorder: any;
  audioChunks: BlobPart[] = [];
  audioBlob!: Blob;

  inputText: string = '';
  messageResponsePairs: MessageResponsePair[] = [];
  private subscription: Subscription;
  pointersLiked: boolean = false;
  pointersDisliked: boolean = false;
  isDropdownOpen: boolean = false;
  display: boolean = false;
  missingUpdate: boolean = false;
  incompleteInfo: boolean = false;
  needsImprovement: boolean = false;
  incorrectResponse: boolean = false;
  cantUnderstand: boolean = false;
  others: boolean = false;
  selectedReasonsArray: string[] = [];
  selectedPairForDislike: any;
  selectedPairIndexForDislike: number;
  feedback: string = '';
  isResponseLoading: boolean = false;
  selectedProduct: any;
  @ViewChild('chatContainer') private chatContainer: ElementRef;
  apiError: boolean = false;
  history: any[] = [];
  $historySubscription: Subscription;
  $voiceSubscription: Subscription;

  constructor(public commonService: CommonService, private apiService: ApiService,
    private dialogService: DialogService, private router: Router, private ngZone: NgZone, private cdRef: ChangeDetectorRef
  ) {
    commonService.productSelection.subscribe((product) => {
      this.selectedProduct = product;
      if (product === "")
        router.navigate(["/home"]);
    })
    this.$historySubscription = this.commonService.history.subscribe((res) => {
      this.history = res;
    })
    this.$voiceSubscription = commonService.isVoiceModeEnabled.subscribe((res) => {
      this.isVoiceEnabled = res;
    })
  }

  adjustTextareaHeight(target: any) {
    const textarea = target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  sendMessage(textarea: HTMLTextAreaElement) {
    if (this.inputText.trim() !== '') {
      // Add the user's message
      const newPair: MessageResponsePair = { message: this.inputText.trim(), loading: true };
      this.messageResponsePairs.push(newPair);
      this.isResponseLoading = true;

      // Reset the textarea height to 40px after sending the message
      setTimeout(() => {
        textarea.style.height = '40px';
      }, 0);

      // Simulate a response after 2 seconds
      let payLoad = {
        session_id: sessionStorage.getItem('sessionId'),
        query: this.inputText.trim()
      }
      const startTime = Date.now();
      this.subscription = this.apiService.getProductResponse(payLoad, this.selectedProduct.company, this.selectedProduct.product, this.selectedProduct.productType).subscribe({
        next: (res) => {
          this.inputText = "";
          newPair.loading = false;
          newPair.response = (this.splitTextIntoChunks(this.formatTextToHTML(res.response), 150));
          newPair.completeResponse = res.response;
          newPair.totalPages = newPair.response.length;
          newPair.currentPage = 0;
          // Ensure the view is updated before scrolling
          this.isResponseLoading = false;
          setTimeout(() => {
            textarea.style.height = '40px';
            document.getElementById('final').scrollIntoView();
          }, 0);
          const endTime = Date.now();
        },
        error: (err) => {
          this.isResponseLoading = false;
          this.showErrorDialog();
          newPair.loading = false;
        }
      })
    }
  }



  resetTextareaHeight() {
    const textarea = document.querySelector('textarea');
    if (textarea) {
      textarea.style.height = 'auto';
    }
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  showDialog(pair, index) {
      this.selectedPairIndexForDislike = index;
      this.selectedPairForDislike = pair;
      this.display = true;
  }

  onSubmit() {

  }

  stopAPI() {
    this.subscription.unsubscribe();
    this.isResponseLoading = false;
    this.messageResponsePairs[this.messageResponsePairs.length - 1].loading = false;
    this.messageResponsePairs[this.messageResponsePairs.length - 1].response = [];
  }

  formatTextToHTML(text) {
    // Replace new lines with <br/> tags
    let formattedText = text.replace(/\n\n/g, '<br/><br/>');
    formattedText = formattedText.replace(/\n/g, '<br/>')
    // Replace strings enclosed within "**" with <b> tags
    formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    return formattedText;
  }

  splitTextIntoChunks(text, wordLimit) {
    const sections = text.split(/(\*\*.*?\*\*|\n\n|<br\/>)/g); // Split by bold tags, newlines, and <br/>
    let chunks = [];
    let currentChunk = '';

    sections.forEach(section => {
      let tempChunk = currentChunk + section;

      // Check if adding this section would exceed the word limit
      if (tempChunk.split(' ').length > wordLimit) {
        // If the current section is bold, ensure it's not at the end of the current chunk
        if (section.includes('<b>')) {
          chunks.push(currentChunk.trim());
          currentChunk = section;
        } else {
          // Move the entire section to the next chunk
          if (currentChunk) {
            chunks.push(currentChunk.trim());
          }
          currentChunk = section;
        }
      } else {
        currentChunk = tempChunk;
      }
    });

    // Add any remaining content
    if (currentChunk) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  }

  previousPage(index): void {
    if (this.messageResponsePairs[index].currentPage! > 0) {
      this.messageResponsePairs[index].currentPage!--;
    }
  }

  nextPage(index): void {
    if (this.messageResponsePairs[index].currentPage! < this.messageResponsePairs[index].totalPages! - 1) {
      this.messageResponsePairs[index].currentPage!++;
    }
  }

  showErrorDialog() {
    this.dialogService.open(ErrorDialogComponent, {
      width: '70%'
    });
  }

  getSelectedReasons() {
    this.selectedReasonsArray = [];
    if (this.missingUpdate) {
      this.selectedReasonsArray.push('Missing critical update(s)');
    }
    if (this.incompleteInfo) {
      this.selectedReasonsArray.push('Incomplete information');
    }
    if (this.needsImprovement) {
      this.selectedReasonsArray.push('Needs improvement');
    }
    if (this.incorrectResponse) {
      this.selectedReasonsArray.push('Incorrect response');
    }
    if (this.cantUnderstand) {
      this.selectedReasonsArray.push("Can't understand");
    }
    if (this.others) {
      this.selectedReasonsArray.push('Others');
    }
    return this.selectedReasonsArray.join(', ');
  }

  responseLiked(pair: any, index: number) {
      let payLoad = {
        session_id: sessionStorage.getItem("sessionId"),
        session_type: "query",
        category: this.selectedProduct.productType,
        company: this.selectedProduct.company,
        product: this.selectedProduct.product,
        user_input: pair.message,
        model_response: pair.completeResponse,
        feedback_type: "positive",
        feedback_category: "Accurate"
      }
      this.apiService.addFeedback(payLoad).subscribe({
        next: (res: any) => {
          this.messageResponsePairs[index].isLiked = true;
          this.messageResponsePairs[index].isDisliked = false;
        },
        error: (err: any) => {
        }
      })
  }

  responseDisLiked() {
    let pair = this.selectedPairForDislike;
    let index = this.selectedPairIndexForDislike;
      let payLoad = {
        session_id: sessionStorage.getItem("sessionId"),
        session_type: "query",
        module: "product_query",
        category: this.selectedProduct.productType,
        company: this.selectedProduct.company,
        product: this.selectedProduct.product,
        user_input: pair.message,
        response_content: pair.completeResponse,
        feedback_type: "negative",
        feedback_category: this.getSelectedReasons(),
        feedback_text: this.feedback
      }
      this.apiService.addFeedback(payLoad).subscribe({
        next: (res: any) => {
          this.messageResponsePairs[index].isDisliked = true;
          this.messageResponsePairs[index].isLiked = false;
          this.display = false;
          this.cantUnderstand = false;
          this.incompleteInfo = false;
          this.incorrectResponse = false;
          this.needsImprovement = false;
          this.missingUpdate = false;
          this.others = false;
          this.feedback = "";
        },
        error: (err: any) => {
        }
      })
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.navigation-options') || target.closest('.toggle-button');

    if (!clickedInside && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  goBack() {
    let lastRoute = this.history[this.history.length - 1];
    this.router.navigate([lastRoute]);
  }

  ngOnDestroy() {
    this.$historySubscription.unsubscribe();
    this.$voiceSubscription.unsubscribe();
  }

  // Toggle voice recognition
  toggleVoiceRecognition() {
    if (!this.isListening) {
      this.startRecording();
    } else {
      this.stopRecording();
    }
  }

  // Stop voice recognition
  stopVoiceRecognition() {
    if (this.recognition) {
      this.recognition.stop();
      this.isListening = false;
      console.log('Voice recognition manually stopped.');
    }
  }


  // Detect language (simple logic based on character patterns)
  detectLanguage(text: string): string {
    const hindiRegex = /[\u0900-\u097F]/;
    const detectedLanguage = hindiRegex.test(text) ? 'hi' : 'en';
    console.log(`Language detected: ${detectedLanguage}`);
    return detectedLanguage;
  }

  startRecording() {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.start();
        this.isListening = true;
        this.voiceError = '';
        this.audioChunks = [];

        this.mediaRecorder.ondataavailable = (event: any) => {
          this.audioChunks.push(event.data);
        };
      })
      .catch(error => {
        this.voiceError = 'Microphone access denied';
      });
  }

  stopRecording() {
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
      this.isListening = false;
      this.mediaRecorder.onstop = () => {
        this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
        this.isProcessing = true;
        this.cdRef.detectChanges(); 
        this.sendAudioToApi(this.audioBlob);
      };
    }
  }

  sendAudioToApi(audioBlob: Blob) {
    const formData = new FormData();
    formData.append('file', audioBlob, 'recording.wav');
    formData.append('language_code','en');
    this.apiService.getTranscription(formData).subscribe((res)=>{
      this.ngZone.run(() => { 
        this.inputText += res.transcription;
        this.isProcessing = false;
        setTimeout(() => {
          const textarea = document.getElementById('input') as HTMLTextAreaElement;
          if (textarea) {
            this.adjustTextareaHeight(textarea);
          }
        });
        this.cdRef.detectChanges();
      });
    })
  }

  logout() {
    this.commonService.logout();
  }
}